export default __webpack_public_path__ + "static/media/four-icon.8eb10084.svg";